import { FunctionComponent, HTMLProps } from "react";
import { useLottie } from "lottie-react";

interface IAnimateLoaderProps extends HTMLProps<"div"> {
    LoaderAnimation: any;
    Loop?: boolean;
}

const defaultProps: IAnimateLoaderProps = {
    Loop: true,
    LoaderAnimation: {}
};

const LoaderComponent: FunctionComponent<IAnimateLoaderProps> = (props: IAnimateLoaderProps) => {

    const options = {
        animationData: props.LoaderAnimation,
        loop: props.loop
    };

    const { View } = useLottie(options);

    const safeStyle =
        props.style && typeof props.style === "object" && !Array.isArray(props.style)
            ? props.style
            : undefined;

    return <div className={props.className || ""} style={safeStyle}>
        {View}
    </div>
}

LoaderComponent.defaultProps = defaultProps;

export default LoaderComponent;